import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  TenantService,
  UserService,
} from '../../_services/index';

import {User} from '../../_models/index';

import {MatDialog, MatDialogConfig} from "@angular/material/dialog";

import {LoginHelper, Recurring, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import * as moment from 'moment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ImplementationControlStatementService} from "../../_services/implementationControlStatement.service";
import {DocumentSelectComponent} from "../documentSelect";
import {IndexConfigService} from "../../_services/index.config.service";
import {Constants} from "../../helpers/constants";
import {ListMessageComponent} from "../listMessage";
import {
  EditImplementationControlStatementSetComponent
} from "../editImplementationControlStatementSet/editImplementationControlStatementSet.component";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "implementation-control-statement-component",
  templateUrl: 'implementation-control-statement.component.html',
  styleUrls: ['./implementation-control-statement.component.scss'],
})

export class ImplementationControlStatementComponent implements OnInit {
  api = window.location.origin;
  items: any[];
  implementationControlStatementId?: string;
  implementationControlStatementSets = [];
  canEdit: boolean = false;
  tenantName: string;
  recurringList: any[];
  approvalCols: any[] = [
    {field: 'startDate', header: 'Period'},
    {field: 'approver', header: 'Approver'},
    {field: 'status', header: 'Approval Status', width: '40px'},
    {field: 'note', header: 'Note', width: '200px'},
  ];
  users: User[] = [];
  rowGroupMetadata: any;
  isMaster: boolean = false;
  settings: any;
  isActionPlanTemplatesVisible: boolean;
  isEditable: boolean;
  constants = Constants;


  constructor(
    public config: IndexConfigService,
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public tenantService: TenantService,
    public clientProfileService: ClientProfileService,
    public implementationControlStatementService: ImplementationControlStatementService) {
    this.recurringList = [];
    for (let i = Recurring.Monthly; i <= Recurring.Yearly; i++) {
      this.recurringList.push({label: Recurring[i].toString(), value: i});
    }
  }

  initForm(value) {
    const controls = {
      name: [value.name, Validators.required],
      category: [value.category, Validators.required],
      text: [value.text, Validators.required],
      ownerId: [null],
      id: [null],
      order: [null],
      view: [false],
      implementationControlStatementSetId: [null]
    };

    const implementationControlStatementForm = this._formBuilder.group(controls);
    implementationControlStatementForm.patchValue(value);
    return implementationControlStatementForm;
  }

  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.canEdit = (currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0 ||
      (currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0;

    this.route.params.subscribe(p => {
      this.implementationControlStatementId = p['implementationControlStatementId'];
    })

    this.tenantService.getCurrent().subscribe(p => {
      this.isActionPlanTemplatesVisible = (currentUser.role & (Role.KingAdmin | Role.Admin | Role.Support | Role.PrimaryManager | Role.PrimaryAdvisorLead | Role.PlatformSupport | Role.AdvisorLead)) != 0;
      this.isEditable = !p || p.isEditICSAndAPEnabled;
    });

    this.isMaster = this.tenantName == Constants.RiskSpongeMaster;
    this.userService.getAllShort(this.tenantName).subscribe(u => this.users = u);
    this.loadImplementationControlStatements();
    this.loadSettings();
  }

  loadImplementationControlStatements() {
    this.implementationControlStatementService.getAllImplementationControlStatementSets().subscribe(t => {
      this.implementationControlStatementSets = t;
      this.implementationControlStatementSets.forEach(s => {
        s.selectedItems = [];
        s.selectedItems.push(s.implementationControlStatements.find(t => t.id == s.implementationControlStatementId) || (s.implementationControlStatementId == 0 ? s.implementationControlStatements[s.implementationControlStatements.length - 1] : s.implementationControlStatements[0]));
        s.implementationControlStatementForms = [];
        s.implementationControlStatements.forEach(p => {
          p.view = true;
          s.implementationControlStatementForms.push(this.initForm(p));
        });
        this.updateRowGroupMetaData(s);
      });
    });
  }

  save(set, i) {
    if (set.implementationControlStatementForms[i].valid) {
      const result = set.implementationControlStatementForms[i].value;

      result.authors = (result.authorList || []).map(a => a.userId).join(',');
      result.implementationControlStatementSetId = set.id;
      this.implementationControlStatementService.saveImplementationControlStatement(result).subscribe(() => {
        set.implementationControlStatements[i] = result;
        this.alertService.success("Successfully saved");
        this.loadImplementationControlStatements();
      });
    }
  }

  editSet(set) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '30%',
      height: 'auto',
      data: { implementationControlStatementSet: set }
    };

    const dialogRef = this.dialog.open(EditImplementationControlStatementSetComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.loadImplementationControlStatements();
      }
    });
  }

  deleteSet(set) {
    this.implementationControlStatementService.deleteImplementationControlStatementsSet(set.id).subscribe(() => {
      this.loadImplementationControlStatements()
    });
  }

  add(set) {
    set.implementationControlStatementForms.push(this.initForm({
      name: "",
      text: "",
      id: 0,
      ownerId: null,
      order: 0,
      category: 'New',
      view: false,
      implementationControlStatementSetId: null
    }));
    const newVal = {name: "", text: "", id: 0};
    set.implementationControlStatements.push(newVal);
    set.selectedItems.push(newVal);
    this.updateRowGroupMetaData(set);
  }

  selectDocument(node) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {}
    };

    const dialogRef = this.dialog.open(DocumentSelectComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const quill = window['quills'].find(q => q.container === node.closest(".p-editor-container").querySelector(".ql-container"));
        const url = this.config.api + "/api/attachments/file?name=" + encodeURIComponent(result._orgData.name) + "&path=" + (result._orgData.folderId || "");
        quill.format('link', url, 'user');
      }
    });
  }

  dropImplementationControlStatement(item) {
    this.implementationControlStatementService.deleteImplementationControlStatement(item.id).subscribe(() => this.loadImplementationControlStatements());
  }

  dropImplementationControlStatements(set, category) {
    this.implementationControlStatementService.deleteImplementationControlStatements(set.implementationControlStatements.filter(i => i.category == category).map(i => i.id)).subscribe(() => this.loadImplementationControlStatements());
  }

  dropAllImplementationControlStatements(set) {
    this.implementationControlStatementService.deleteImplementationControlStatements(set.implementationControlStatements.map(i => i.id)).subscribe(() => this.loadImplementationControlStatements());
  }

  getFullName(user) {
    if (!user) {
      return '';
    }
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  getFullNameById(userId) {
    const user = this.users.find(u => u.userId == userId);
    if (!user) return null;
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress || user.emailAddress;
  }

  loadSettings() {
    this.clientProfileService.getSettings(this.tenantName).subscribe(t => this.settings = t);
  }

  up(set, item) {
    const i = set.implementationControlStatements.indexOf(item);
    set.implementationControlStatements[i] = set.implementationControlStatements[i - 1];
    set.implementationControlStatements[i - 1] = item;
    this.implementationControlStatementService.setImplementationControlStatementOrder(set.implementationControlStatements.map(p => p.id)).subscribe(() => {
      this.loadImplementationControlStatements();
    })
  }

  down(set, item) {
    const i = set.implementationControlStatements.indexOf(item);
    set.implementationControlStatements[i] = set.implementationControlStatements[i + 1];
    set.implementationControlStatements[i + 1] = item;
    this.implementationControlStatementService.setImplementationControlStatementOrder(set.implementationControlStatements.map(p => p.id)).subscribe(() => {
      this.loadImplementationControlStatements();
    })
  }

  addToken(html) {
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }

  updateRowGroupMetaData(set) {
    const data = set.implementationControlStatements;
    this.rowGroupMetadata = this.rowGroupMetadata || {};
    this.rowGroupMetadata[set.id] = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        rowData.category = rowData.category || ' ';
        let brand = rowData.category || ' ';
        if (i == 0) {
          this.rowGroupMetadata[set.id][brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.category || ' ';
          if (brand === previousRowGroup)
            this.rowGroupMetadata[set.id][brand].size++;
          else
            this.rowGroupMetadata[set.id][brand] = {index: i, size: 1};
        }
      }
    }
  }

  uploadItems(event, set) {
    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.implementationControlStatementService.uploadItems(file, set.id).subscribe(
        (res) => {

          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.loadImplementationControlStatements();

        },
        (error) => {
          const errorMessage = 'An error occurred while upload implementation control statement items.';
          this.alertService.error(errorMessage);
        });
    }
  }
}
